export const TOGGLE_PRODUCT = 'TOGGLE_PRODUCT';
export function toggleProduct(categoryId, productId) {
  return {
    type: TOGGLE_PRODUCT,
    categoryId,
    productId,
  };
}

export const TOGGLE_CATEGORY = 'TOGGLE_CATEGORY';
export function toggleCategory(categoryId) {
  return {
    type: TOGGLE_CATEGORY,
    categoryId,
  };
}

export const CHANGE_PRODUCT_FORM_QTTY = 'CHANGE_PRODUCT_FORM_QTTY';
export function changeProductQuantity(categoryId, productId, quantity) {
  return {
    type: CHANGE_PRODUCT_FORM_QTTY,
    categoryId,
    productId,
    quantity,
  };
}

export const SET_CATEGORIES = 'SET_CATEGORIES';
export function setCategories(categories) {
  return {
    type: SET_CATEGORIES,
    categories,
  };
}

export const SET_MENU_DATA = 'SET_MENU_DATA';
export function setMenuData(menu) {
  return {
    type: SET_MENU_DATA,
    menu,
  };
}

export const CLEAR_PRODUCTS_SELECTED = 'CLEAR_PRODUCTS_SELECTED';
export const clearProductsSelected = () => ({
  type: CLEAR_PRODUCTS_SELECTED,
});

export const CLEAR_NEW_MENU_CATEGORIES = 'CLEAR_NEW_MENU_CATEGORIES';
export const clearNewMenuCategories = () => ({
  type: CLEAR_NEW_MENU_CATEGORIES,
});



// WEBPACK FOOTER //
// ./src/store/newMenu/actions.js